import { Role } from '../role/role';

export const DELETED_USER_TOOLTIP = 'This user has deleted their account';

export const USERNAME_BLACKLIST = ['deactivated'];

export const USER_ROLES_CREATION_OPTIONS = [
  { label: 'Tài khoản Khách', value: Role.SELLER },
  { label: 'Tài khoản Nhân viên', value: Role.EMPLOYEE },
];
